"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var __2 = require("../../..");
var context_1 = require("../../../context");
var enums_1 = require("../../../types/enums");
var Card_1 = require("../../Card");
var Tabs_1 = require("../../Tabs/Tabs");
var TextArea_1 = __importDefault(require("../../TextArea"));
var errorKeys = ['address', 'phone_number', 'consent_to_contact', 'name'];
var CarersDetailsForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e;
    var _f = context_1.useSemantics(), options = _f.options, trans = _f.trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    var _g = react_1.useState(errors.carer || {}), formErrors = _g[0], setFormErrors = _g[1];
    react_1.useEffect(function () { return setTabError(tabId, __2.objectHasAnyKey(formErrors, errorKeys)); }, [formErrors]);
    react_1.useEffect(function () {
        var errs = {};
        if (errors.carer && Object.keys(errors.carer).length > 0) {
            errs = errors.carer;
        }
        if (errors.has_carer) {
            errs.has_carer = errors.has_carer;
        }
        setFormErrors(Object.keys(errs).length > 0 ? errs : {});
    }, [errors.carer, errors.has_carer]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.client-carer'), subHeading: trans('optiiva::headings.carers') },
        react_1.default.createElement(__1.FormControl, { errors: errors.has_carer, label: trans('optiiva::labels.has-carer') },
            react_1.default.createElement(__1.Select, { width: "xs", options: options.boolean(), name: "has_carer" })),
        react_1.default.createElement(__1.FormControl, { errors: (_b = errors.carer) === null || _b === void 0 ? void 0 : _b.consent_to_contact, label: trans('optiiva::labels.carers-consent-to-contact') },
            react_1.default.createElement(__1.RadioInput, { name: "carer.consent_to_contact", label: trans('laravel-utils::enum.boolean.yes'), value: enums_1.BooleanOption.YES }),
            react_1.default.createElement(__1.RadioInput, { name: "carer.consent_to_contact", label: trans('laravel-utils::enum.boolean.no'), value: enums_1.BooleanOption.NO })),
        react_1.default.createElement(__1.FormControl, { errors: ((_c = errors.carer) === null || _c === void 0 ? void 0 : _c.name) || [], label: trans('optiiva::labels.carers-name') },
            react_1.default.createElement(__1.Input, { name: "carer.name", maxLength: 150 })),
        react_1.default.createElement(__1.FormControl, { errors: ((_d = errors.carer) === null || _d === void 0 ? void 0 : _d.phone_primary) || [], label: trans('optiiva::labels.carers-phone-number') },
            react_1.default.createElement(__1.Input, { name: "carer.phone_primary", maxLength: 32 })),
        react_1.default.createElement(__1.FormControl, { errors: ((_e = errors.carer) === null || _e === void 0 ? void 0 : _e.address) || [], label: trans('optiiva::labels.address') },
            react_1.default.createElement(TextArea_1.default, { name: "carer.address", maxLength: 1500 }))));
};
exports.default = CarersDetailsForm;
//# sourceMappingURL=CarersDetailsForm.js.map